export default __webpack_public_path__ + "static/media/github.bcd9bda4.png";